import { initContract } from '@ts-rest/core';
import { adminGiftCardIntegrationContract } from './giftCardIntegration.admin.contract';
import { authGiftCardIntegrationContract } from './giftCardIntegration.auth.contract';

const c = initContract();

export const giftCardIntegrationContract = c.router(
  {
    admin: adminGiftCardIntegrationContract,
    auth: authGiftCardIntegrationContract,
  },
  {
    pathPrefix: '/gift-card-integration',
    strictStatusCodes: true,
  }
);

export * from './giftCardIntegration.admin.contract';
export * from './giftCardIntegration.auth.contract';
export * from './models';
